import { LocaleKey } from '../../constants';
import { UserNotConfirmedError } from '../../types';
import { IdpErrorName } from '../../shared/idp-error-names';

export { IdpErrorName } from '../../shared/idp-error-names';

/** Amplify SDK `signInStep` values — dictated by AWS, not us. */
export enum AmplifySignInStep {
  ConfirmSignUp          = 'CONFIRM_SIGN_UP',
  NewPasswordRequired    = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
}

/** Amplify SDK `authFlowType` values — dictated by AWS, not us. */
export enum AmplifyAuthFlow {
  UserPasswordAuth = 'USER_PASSWORD_AUTH',
  UserSrpAuth      = 'USER_SRP_AUTH',
}

const ERROR_MAP: Partial<Record<IdpErrorName, LocaleKey>> = {
  [IdpErrorName.NotAuthorized]:    LocaleKey.InvalidPassword,
  [IdpErrorName.UserNotFound]:     LocaleKey.InvalidPassword,
  [IdpErrorName.UsernameExists]:   LocaleKey.EmailTaken,
  [IdpErrorName.InvalidPassword]:  LocaleKey.InvalidPasswordFormat,
  [IdpErrorName.CodeMismatch]:     LocaleKey.InvalidCode,
  [IdpErrorName.ExpiredCode]:      LocaleKey.ExpiredCode,
};

export function translateIdpError(
  error: unknown,
  t: (key: string, opts?: { defaultValue: string }) => string,
  fallback: string = LocaleKey.Other,
): never {
  if (error instanceof UserNotConfirmedError) throw error;

  const name = (error as { name?: string } | null)?.name as IdpErrorName | undefined;
  if (name && name in ERROR_MAP) {
    throw new Error(t(ERROR_MAP[name]!));
  }
  if (error instanceof Error) throw error;
  throw new Error(t(fallback));
}
